module.exports = __webpack_public_path__ + "img/Obstfelder_Et_urolig_nomadeliv.35649202.jpg";